import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'debtor-panel-bad-route',
  imports: [
    MatButtonModule,
    MatIconModule,
  ],
  template: `
    <div class="bad-route">
      <h1>Zły adres</h1>
      <p>Przepraszamy, ale strona pod podanym adresem nie istnieje.</p>
      <p>Sprawdź, czy link który otrzymałeś jest poprawny.</p>
      <section>
        <div class="example-button-row">
        <a href="#" class="home-link" (click)="navigateToHome($event)">Wróć do strony głównej</a>
        </div>
      </section>
    </div>
  `,
  styles: [`
    .bad-route {
      text-align: center;
      padding: 2rem;
    }
  `],
})
export class BadRouteComponent {
  private router = inject(Router);

  public navigateToHome(event: Event): void {
    event.preventDefault();
    this.router.navigate(['']);
  }
}